import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import {
  UserCheck, ShieldCheck, FileCheck, Briefcase, Rocket, TrendingUp,
  Sparkles, Users, Send, CheckCircle2, Clock,
} from 'lucide-react';

const IKONER = { UserCheck, ShieldCheck, FileCheck, Briefcase, Rocket, TrendingUp };

const Tjenester = () => {
  const { user, firma } = useAuth();
  const [katalog, setKatalog] = useState([]);
  const [mine, setMine] = useState([]);
  const [valgt, setValgt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [feil, setFeil] = useState('');
  const [skjema, setSkjema] = useState({ melding: '', kontakt_navn: '', kontakt_epost: '', kontakt_tlf: '' });

  const lastMine = () => api.get('/tjenester/mine').then((r) => setMine(r.data)).catch(() => {});

  useEffect(() => {
    api.get('/tjenester').then((r) => setKatalog(r.data.katalog || [])).catch(() => {});
    lastMine();
  }, []);

  const aapne = (t) => {
    setValgt(t);
    setFeil('');
    setSkjema({
      melding: '',
      kontakt_navn: user?.navn || '',
      kontakt_epost: user?.epost || '',
      kontakt_tlf: '',
    });
  };

  const send = async () => {
    setBusy(true); setFeil('');
    try {
      await api.post('/tjenester/foresporsel', { tjeneste: valgt.id, ...skjema });
      setValgt(null);
      lastMine();
    } catch (e) {
      setFeil(e.response?.data?.error || 'Kunne ikke sende forespørsel.');
    } finally { setBusy(false); }
  };

  const statusBadge = (s) => {
    if (s === 'kontaktet') return <span className="badge" style={{ background: '#fbbf24', color: '#111', fontSize: 10 }}><Clock size={10} /> Kontaktet</span>;
    if (s === 'lukket') return <span className="badge badge-success" style={{ fontSize: 10 }}><CheckCircle2 size={10} /> Fullført</span>;
    return <span className="badge" style={{ fontSize: 10 }}>Mottatt</span>;
  };

  return (
    <>
      <PageHeader title="Tjenester" subtitle="Profesjonell hjelp når du trenger det – regnskapsfører, revisor og mer" />

      <Card style={{ marginBottom: 12, padding: 16, background: 'linear-gradient(120deg, var(--theme-accent-soft, rgba(59,130,246,.08)), transparent)' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
          <Sparkles size={20} style={{ color: 'var(--theme-accent)', flexShrink: 0, marginTop: 2 }} />
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Du fører selv – vi hjelper når det trengs</div>
            <p className="fm-text-muted" style={{ fontSize: 12, margin: '2px 0 0' }}>
              Regnino gir deg alt for å drifte regnskapet selv. Trenger du en autorisert
              regnskapsfører, revisor eller hjelp til årsoppgjøret, kan du be om et
              uforpliktende tilbud her – vi kobler deg med en kvalifisert partner.
            </p>
          </div>
        </div>
      </Card>

      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 12 }}>
        {katalog.map((t) => {
          const Ikon = IKONER[t.ikon] || Sparkles;
          return (
            <Card key={t.id} style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center',
                              justifyContent: 'center', background: 'var(--theme-accent-soft, rgba(59,130,246,.1))',
                              color: 'var(--theme-accent)' }}>
                  <Ikon size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{t.navn}</div>
                  <div className="fm-text-muted" style={{ fontSize: 11 }}>{t.fra_pris}</div>
                </div>
              </div>
              <p className="fm-text-muted" style={{ fontSize: 12, margin: 0, flex: 1, lineHeight: 1.5 }}>
                {t.beskrivelse}
              </p>
              <button className="btn-primary" style={{ fontSize: 12, justifyContent: 'center' }}
                      onClick={() => aapne(t)}>
                <Send size={12} /> Be om tilbud
              </button>
            </Card>
          );
        })}
      </div>

      {/* Inviter egen regnskapsfører */}
      <Card style={{ marginTop: 12, padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center',
                        justifyContent: 'center', background: 'var(--theme-accent-soft, rgba(59,130,246,.1))',
                        color: 'var(--theme-accent)', flexShrink: 0 }}>
            <Users size={20} />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Har du allerede en regnskapsfører?</div>
            <p className="fm-text-muted" style={{ fontSize: 12, margin: '2px 0 0' }}>
              Inviter regnskapsføreren eller revisoren din som bruker – gratis. Da jobber
              dere i samme system med riktige tilganger.
            </p>
          </div>
          <Link to="/brukere" className="btn-secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
            Inviter bruker
          </Link>
        </div>
      </Card>

      {/* Mine forespørsler */}
      {mine.length > 0 && (
        <Card style={{ marginTop: 12, padding: 0 }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--theme-border)', fontWeight: 600, fontSize: 13 }}>
            Mine forespørsler
          </div>
          <table>
            <thead><tr>
              <th>Tjeneste</th><th>Sendt</th><th>Status</th>
            </tr></thead>
            <tbody>
              {mine.map((m) => (
                <tr key={m.id}>
                  <td><b>{m.tjeneste_navn}</b></td>
                  <td className="fm-text-muted" style={{ fontSize: 12 }}>{(m.opprettet || '').slice(0, 10)}</td>
                  <td>{statusBadge(m.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}

      <Modal open={!!valgt} onClose={() => setValgt(null)}
             title={valgt ? `Be om tilbud – ${valgt.navn}` : ''}
             footer={<>
               <button className="btn-ghost" onClick={() => setValgt(null)}>Avbryt</button>
               <button className="btn-primary" onClick={send} disabled={busy}>
                 {busy ? 'Sender…' : 'Send forespørsel'}
               </button>
             </>}>
        {valgt && (
          <>
            <p className="fm-text-muted" style={{ fontSize: 12, marginTop: 0 }}>
              {valgt.beskrivelse} Vi tar kontakt med et uforpliktende tilbud.
            </p>
            <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div>
                <label>Kontaktnavn</label>
                <input value={skjema.kontakt_navn} onChange={(e) => setSkjema({ ...skjema, kontakt_navn: e.target.value })} />
              </div>
              <div>
                <label>Telefon</label>
                <input value={skjema.kontakt_tlf} onChange={(e) => setSkjema({ ...skjema, kontakt_tlf: e.target.value })} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label>E-post</label>
                <input type="email" value={skjema.kontakt_epost} onChange={(e) => setSkjema({ ...skjema, kontakt_epost: e.target.value })} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label>Melding (valgfritt)</label>
                <textarea rows={4} value={skjema.melding}
                          onChange={(e) => setSkjema({ ...skjema, melding: e.target.value })}
                          placeholder="Fortell kort om behovet ditt…" />
              </div>
            </div>
            {feil && <div className="badge badge-danger" style={{ marginTop: 10 }}>{feil}</div>}
          </>
        )}
      </Modal>
    </>
  );
};

export default Tjenester;
